import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { NotificationData } from '../../../../services/notification.service';
import { buildWayPurchaseActiveSubscriptionDisplayVm } from '../../utils/way-purchase-active-subscription-display.util';
import { WayPurchaseActiveSubscriptionDisplayVm } from '../../models/way-purchase.models';
import { WAY_PURCHASE_PLATE_PLACEHOLDER } from '../../utils/way-purchase-plate.util';
import {
  resolveWayPurchaseDetailView,
  resolveWayPurchaseUnredeemableReason,
  shouldShowWayPurchaseActiveSubscriptionLayout,
  WayPurchaseUnavailableKind,
} from '../../utils/way-purchase-layout.util';

@Component({
  selector: 'app-way-purchase-active-subscription-layout',
  standalone: true,
  imports: [CommonModule, FormsModule, MatInputModule],
  templateUrl: './way-purchase-active-subscription-layout.component.html',
  styleUrls: ['./way-purchase-active-subscription-layout.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WayPurchaseActiveSubscriptionLayoutComponent implements OnChanges {
  @Input() notification: NotificationData | null = null;
  @Input() needsPlateEntry = false;
  @Input() plateInput = '';
  @Input() plateInputError = '';
  @Input() plateInputDisabled = false;
  @Output() plateInputChange = new EventEmitter<string>();

  readonly platePlaceholder = WAY_PURCHASE_PLATE_PLACEHOLDER;
  isVisible = false;
  isUnavailable = false;
  unavailableKind: WayPurchaseUnavailableKind | null = null;
  unavailableReason = '';
  displayVm: WayPurchaseActiveSubscriptionDisplayVm | null = null;

  get showUnredeemableBadge(): boolean {
    return this.isUnavailable && this.unavailableKind === 'unredeemable';
  }

  get showAlreadyRedeemedInfoChip(): boolean {
    return this.isUnavailable && this.unavailableKind === 'already_redeemed';
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['notification']) {
      const detail = resolveWayPurchaseDetailView(this.notification);
      this.isVisible = shouldShowWayPurchaseActiveSubscriptionLayout(this.notification);
      this.displayVm = detail ? buildWayPurchaseActiveSubscriptionDisplayVm(detail.data) : null;
      this.isUnavailable = detail?.isUnavailable === true;
      this.unavailableKind = detail?.unavailableKind ?? null;
      this.unavailableReason = this.isUnavailable
        ? resolveWayPurchaseUnredeemableReason(detail?.data, this.notification?.message)
        : '';
    }
  }

  onPlateInput(value: string): void {
    this.plateInputChange.emit(value);
  }
}
